import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ReservationAssignmentTypeId {
  ASSIGNED = 1,
  FLOATING = 2,
}

export class ReservationAssignmentType extends Codebook<ReservationAssignmentTypeId> {
  static readonly ASSIGNED = new ReservationAssignmentType(
    ReservationAssignmentTypeId.ASSIGNED,
    () => $t('Assigned'),
  )
  static readonly FLOATING = new ReservationAssignmentType(
    ReservationAssignmentTypeId.FLOATING,
    () => $t('Unassigned'),
  )

  private constructor(
    public readonly id: ReservationAssignmentTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
